class BlogFacets {
    constructor() {

        this.wrapper = document.querySelector('.main-blog__inner');

        if (this.wrapper) {

            this.filterForm = document.querySelector('.main-blog__filters-form');
            this.filterTrigger = document.querySelector('.main-filter__trigger');
            this.filterContainer = document.querySelector('.main-filter__filters');
            this.filterClose = document.querySelector('#main-filter__close');
            this.filterOverlay = document.querySelector('.main-filters__overlay');
            this.sectionID = document.querySelector('.main-blog__list').id;

            this.setListeners();
        }


    }

    setListeners() {

        this.filterTrigger.addEventListener('click', (e) => {
            e.preventDefault();

            this.filterContainer.classList.add('active');
            this.filterOverlay.classList.add('active');

        });

        this.filterOverlay.addEventListener('click', (e) => {
            this.filterContainer.classList.remove('active');
            this.filterOverlay.classList.remove('active');
        }); 

        this.filterClose.addEventListener('click', (e) => {
            e.preventDefault();

            this.filterContainer.classList.remove('active');
            this.filterOverlay.classList.remove('active');
        }); 

        this.filterForm.addEventListener('change', () => {
            this.filterBy();
        });


    }

    filterBy() {

        let selectedTags = Array.from(
            this.filterForm.querySelectorAll('input[type=checkbox]:checked')
        );

        if (selectedTags.length > 0) {

            let fetches = selectedTags.map(tag => {
                let _url = `${window.location.pathname}/tagged/${tag.id}?section_id=${this.sectionID}`;
                return fetch(_url)
                    .then(r => r.text())
                    .then(html => {
                        let doc = new DOMParser().parseFromString(html, 'text/html');
                        return [...doc.querySelectorAll(`#${this.sectionID} .article-card`)];
                    });
            });

            Promise.all(fetches).then(resultsArrays => {
                let allArticles = resultsArrays.flat();

                let seen = new Set();
                let uniqueArticles = allArticles.filter(article => {
                    let href = article.querySelector('.article-card__title').href;
                    if (seen.has(href)) return false;
                    seen.add(href);
                    return true;
                });

                let container = document.querySelector('#' + this.sectionID);
                container.innerHTML = '';
                uniqueArticles.forEach(article => container.appendChild(article));
            });

        } else {

            let _url = `${window.location.pathname}?${this.sectionID}`;

            fetch(_url)
                .then((response) => response.text())
                .then(response => {
                    const html = new DOMParser().parseFromString(response, 'text/html');
                    const sourceQty = html.querySelector('#' + this.sectionID);

                    document.querySelector('#' + this.sectionID).innerHTML = sourceQty.innerHTML;

                })

        }


        


    }
}

let blogFacets = new BlogFacets();

